module.exports = __webpack_public_path__ + "static/media/bratislava.f7d60877.jpg";